var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["contentful/ugc-display-tile-content.j2"] = require( "contentful/ugc-display-tile-content.j2" );
dependencies["social/heart.j2"] = require( "social/heart.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-pdp-carousel-item.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.config.captionMaxLength",""]));
frame.set("captionMaxLength", t_1, true);
if(frame.topLevel) {
context.setVariable("captionMaxLength", t_1);
}
if(frame.topLevel) {
context.addExport("captionMaxLength", t_1);
}
var t_2;
t_2 = runtime.contextOrFrameLookup(context, frame, "item");
frame.set("displayTile", t_2, true);
if(frame.topLevel) {
context.setVariable("displayTile", t_2);
}
if(frame.topLevel) {
context.addExport("displayTile", t_2);
}
output += "\n";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"photo")),"large_square")),"url");
frame.set("largePhotoUrl", t_3, true);
if(frame.topLevel) {
context.setVariable("largePhotoUrl", t_3);
}
if(frame.topLevel) {
context.addExport("largePhotoUrl", t_3);
}
output += "\n\n<div class=\"o-slider__slide o-slider__slide--product-image js-slider__slide\">\n\n    <div class=\"g-ugc-pdp-grid c-ugc-pdp__content-outer\">\n\n        <div class=\"o-column o-extra-small--12 o-large--6\">\n\n            <div class=\"c-ugc-pdp__image-outer js-ugc-tray-image-container\">\n\n                ";
env.getTemplate("contentful/ugc-display-tile-content.j2", false, "core/templates/contentful/ugc-pdp-carousel-item.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-column o-extra-small--12 o-large--6\">\n\n            <div class=\"c-ugc-pdp__info-outer\">\n\n                <span class=\"c-ugc-pdp__username\" data-qa-ugc-username=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"user")),"username"), env.opts.autoescape);
output += ">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"user")),"username"), env.opts.autoescape);
output += "\n                </span>\n\n                <div class=\"c-ugc-pdp__like-container\">\n\n                    <span class=\"c-ugc-pdp__heart\" data-qa-ugc-heart-svg>";
env.getTemplate("social/heart.j2", false, "core/templates/contentful/ugc-pdp-carousel-item.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "</span>\n\n                    <span class=\"c-ugc-pdp__like-count\" data-qa-ugc-like-count=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"like_count"), env.opts.autoescape);
output += ">\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"like_count"), env.opts.autoescape);
output += "\n                    </span>\n\n                </div>\n\n                <span class=\"c-ugc-pdp__caption\" data-qa-ugc-caption=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"caption"), env.opts.autoescape);
output += ">\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "captionMaxLength")) {
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("truncate").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"caption"),runtime.contextOrFrameLookup(context, frame, "captionMaxLength")), env.opts.autoescape);
output += "\n                    ";
;
}
else {
output += "\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"caption"), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                </span>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-pdp-carousel-item.j2"] , dependencies)